import angular from 'angular';
import { HellosignEmbeddedIframeComponent } from './hellosign-embedded-iframe.component';
import { LoaderModule } from '@buildium/angularjs-core/dist/components/loader';
import { ESignaturesHelloSignClientServiceModule } from '../../services/esignatures-hellosign-client/esignatures-hellosign-client-service.module';

export const HellosignEmbeddedIframeModule = angular.module('buildium.manager.leases.esignatures.components.hellosignEmbeddedIframe', [
    LoaderModule.name,
    ESignaturesHelloSignClientServiceModule.name
])
    .component('bdHellosignEmbeddedIframe', HellosignEmbeddedIframeComponent);
